import { Modal } from 'antd';

interface CancelConfirmDialogProps {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
}

const CancelConfirmDialog = ({
  isOpen,
  onOk,
  onCancel,
}: CancelConfirmDialogProps) => {
  return (
    <Modal
      width={400}
      title="取消发布确认"
      open={isOpen}
      onOk={onOk}
      okText="确认"
      okButtonProps={{ danger: true }}
      cancelText="取消"
      onCancel={onCancel}
    >
      <p>确定要取消发布吗？</p>
    </Modal>
  );
};

export default CancelConfirmDialog;
